// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { useChat } from '../../hooks/useChat';
import ChatMessageList from './ChatMessageList';
import ChatInput from './ChatInput';
import ChatSessionSidebar from './ChatSessionSidebar';
import './ChatFullView.css';

function getSessionTitle(
  sessionId: string | undefined,
  messages: { role: string; content: string }[]
): string {
  if (!sessionId) return 'New Session';
  const firstUserMsg = messages.find(m => m.role === 'user');
  if (!firstUserMsg) return 'New Session';
  const words = firstUserMsg.content.trim().split(/\s+/);
  const preview = words.slice(0, 6).join(' ');
  return words.length > 6 ? `${preview}...` : preview;
}

function ChatFullView() {
  const {
    messages,
    inputValue,
    setInputValue,
    isThinking,
    sessionId,
    sessions,
    loadingSessions,
    sidebarOpen,
    setSidebarOpen,
    messagesEndRef,
    handleSendMessage,
    handleNewChat,
    handleSelectSession,
  } = useChat();

  const sessionTitle = getSessionTitle(sessionId, messages);

  return (
    <div className="chat-full-view">
      <ChatSessionSidebar
        isOpen={sidebarOpen}
        sessions={sessions}
        loading={loadingSessions}
        activeSessionId={sessionId}
        onClose={() => setSidebarOpen(false)}
        onNewChat={handleNewChat}
        onSelectSession={handleSelectSession}
      />

      <div className="chat-full-main">
        <div className="chat-toolbar">
          <button
            className={`chat-sidebar-toggle ${sidebarOpen ? 'chat-sidebar-toggle-active' : ''}`}
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle session history"
            title="Chat history"
          >
            ☰
          </button>
          <span className="chat-toolbar-title">{sessionTitle}</span>
        </div>

        <ChatMessageList
          messages={messages}
          isThinking={isThinking}
          messagesEndRef={messagesEndRef}
        />

        <ChatInput
          inputValue={inputValue}
          setInputValue={setInputValue}
          isThinking={isThinking}
          sessionId={sessionId}
          onSubmit={handleSendMessage}
        />
      </div>
    </div>
  );
}

export default ChatFullView;
